module.exports = __webpack_public_path__ + "img/banner@2x.25e60b85.png";